import {useState} from "react";
import {Avatar, Button, List, Modal, Space, Table, Tag, Typography} from "antd";
import {CSVLink} from "react-csv";
import {LinkOutlined, MessageOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

export const DiseaseMiRNAList = ({ data, isLoading, name = '', entityType = '' }) => {
  const [showSentence, setShowSentence] = useState(false)
  const [item, setItem] = useState({})

  let headers = [
    {label: 'RNA', key: 'RNA'},
    {label: 'disease', key: 'disease'},
    {label: 'doi', key: 'doi'},
    {label: 'abstract', key: 'abstract'},
    {label: 'title', key: 'title'},
    {label: 'diseaseOntology', key: 'diseaseOntology.node'},
    {label: 'diseaseDefinition', key: 'diseaseOntology.definition'},
  ]
  const columns = [
    {
      key: 'disease',
      dataIndex: 'disease',
      title: 'Disease',
      render: item => <Link to={`/diseases/${item}`}>{item.trim()[0].toUpperCase() + item.trim().substring(1)}</Link>,
      sorter: (a, b) => a.disease.localeCompare(b.disease)
    },
    {
      key: 'RNA',
      dataIndex: 'RNA',
      title: 'RNA',
      render: item => <Link to={`/miRNAs/${item}`}>{item.trim()}</Link>,
      sorter: (a, b) => a.RNA.localeCompare(b.RNA)
    },
    {
      key: 'association',
      dataIndex: 'association',
      title: 'Association',
      render: item => <Tag color={item === 'Verified' ? 'success' : item === 'Medium' ? 'warning' : item === 'Low' ? 'error' : 'default'}>{item}</Tag>,
      filters: [
        {
          text: 'Low',
          value: 'Low',
        },
        {
          text: 'Medium',
          value: 'Medium',
        },
        {
          text: 'High',
          value: 'High',
        },
        {
          text: 'Verified',
          value: 'Verified',
        },
      ],
      onFilter: (value, record) => record.association.indexOf(value) === 0,
    },
    {
      key: 'cosine',
      dataIndex: 'cosine',
      title: 'Cosine',
      render: item => <Tag color="processing">{item}</Tag>,
      sorter: (a, b) => a.cosine - b.cosine
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (_, item) => <Space>
        <Button onClick={() => {
          setItem(item)
          setShowSentence(true)
        }} icon={<MessageOutlined />} />
        <Button target="_blank" href={item.diseaseOntology ? `https://disease-ontology.org/term/${item.diseaseOntology.node}` : ''} icon={<LinkOutlined />} />
      </Space>
    }
  ]
  return(
    <>
      <Table columns={columns} loading={isLoading} dataSource={data} rowKey={r => r.id} scroll={{ x: true }} />
      <div style={{ textAlign: 'center' }}>
        <Button type="primary">
          <CSVLink filename={name ?? "disease_miRNA.csv"} headers={headers} data={data}>Download CSV</CSVLink>
        </Button>
      </div>
      <Modal
        title={item.title}
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        <Typography.Title level={4}>Abstract: </Typography.Title>
        <p>
          {item.abstract}
        </p>
        {item.doi !== '' ? <>
          <Typography.Title level={4}>DOI: </Typography.Title>
          <p>
            <a target="_blank" href={`https://doi.org/${item.doi}`}>{item.doi}</a>
          </p>
        </> : ''}
      </Modal>
    </>
  )
}